import { createFileRoute } from '@tanstack/react-router';
import { PortalVpsDispatches } from '@/features/portal/PortalVpsDispatches';

/**
 * `?commessa=` è l'atterraggio dalla scheda della commessa. Sta nell'URL e non in uno
 * stato condiviso perché così il collegamento si può salvare e rimandare: «guarda le
 * attività di questa commessa» è un link, non una serie di istruzioni.
 */
export const Route = createFileRoute('/_portal/portal/verbali')({
  validateSearch: (s: Record<string, unknown>): { project?: string } => ({
    project: typeof s.commessa === 'string' && s.commessa ? s.commessa : undefined,
  }),
  component: PortalVpsDispatches,
});
